/* eslint-disable max-len */
import { SvgProps } from './types'

export const PersonChartIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="67"
      height="64"
      viewBox="0 0 67 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
    <g clipPath="url(#clip0_1020_2398)">
      <path d="M34.5589 39.5337H65.7942V0.875488H12.0742V13.0188" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16.5421 28.4324C19.9842 28.4324 22.7746 25.4426 22.7746 21.7545C22.7746 18.0664 19.9842 15.0767 16.5421 15.0767C13.1 15.0767 10.3096 18.0664 10.3096 21.7545C10.3096 25.4426 13.1 28.4324 16.5421 28.4324Z" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M24.6054 43.2692L30.2034 49.3572C31.2278 50.4713 32.6753 51.1004 34.1888 51.1004H40.2561C41.9943 51.1004 43.5673 50.4058 44.7107 49.272C45.8475 48.1448 46.5547 46.5786 46.5547 44.8551H35.894L28.7097 36.7289C26.4493 34.1797 23.191 32.7183 19.7674 32.7183C16.628 32.7183 13.1317 32.7379 10.0452 32.7576C5.33938 32.7969 1.53906 36.5913 1.53906 41.2638V56.1661C1.53906 58.5516 3.48879 60.4848 5.89456 60.4848H7.83107" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M24.4335 63.1324V42.2207" stroke={drawColor} strokeWidth="2.65" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.83105 42.2207V63.1324" stroke={drawColor} strokeWidth="2.65" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M57.3806 19.6443V9.83398H47.48" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M57.189 10.1421L43.8713 23.3471H33.0982L27.6786 28.7208" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1020_2398">
        <rect width="66" height="64" fill="white" transform="translate(0.666626 0.00390625)"/>
      </clipPath>
    </defs>
    </svg>
  )
}
